export enum ChipModeEnum {
  critical,
  danger,
  high,
  warning,
  medium,
  success,
  low,
  info,
  running,
  unknown,
  disabled,
}
